import { useMemo, useState } from 'react';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { useAuthWrapper } from '@weareopenr/authkit';
import { usePricingCategories } from 'src/hooks/usePricingCategories/usePricingCategories';
import { pricingCategoriesToSelectOptions } from 'src/utils/pricingCategories';

export const usePricingCategoryFilter = (priceSchemeId: string) => {
  const [searchPricingCategories, setSearchPricingCategories] = useState<string[]>([]);
  const { featureFlags } = useAuthWrapper();
  const hasPricingCategoryFilterFeature = featureFlags.includes('pricing_categories');
  const { nestedCategories } = usePricingCategories(priceSchemeId, {
    enabled: hasPricingCategoryFilterFeature,
  });
  const pricingCategoryOptions: SelectedMultiOption[] = useMemo(
    () => pricingCategoriesToSelectOptions(nestedCategories),
    [nestedCategories],
  );

  return {
    searchPricingCategories,
    setSearchPricingCategories,
    hasPricingCategoryFilterFeature,
    pricingCategoryOptions,
  };
};
